export default "__VITE_ASSET__DYz5cxGH__"